import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { Theme } from '@constants';
import { useContextNodeHandle, useContextReference } from '@hooks';

import { clearStorage, getAllStorage } from '../../../helpers/storage';
import { FocusableHighlight } from '../../focusable/FocusableHighlight/FocusableHighlight';
import { TWCButton } from '../../focusable/TWCButton/TWCButton';
import { TWCPage } from '../../primitives/TWCPage/TWCPage';
import { TWCScrollView } from '../../primitives/TWCScrollView/TWCScrollView';
import { TWCText } from '../../primitives/TWCText/TWCText';

const testIDS = {
  clearButton: 'debug_storage_page_clear_button',
  display: 'debug_storage_page_storage_display',
};

export const DebugLocalStoragePage = ({ route }) => {
  const { debugItem } = route.params;

  return (
    <TWCPage
      childIds={[testIDS.clearButton, testIDS.display]}
      firstFocus={testIDS.clearButton}
      pageID={debugItem.pageID}
    >
      <View style={styles.pageTitleWrapper}>
        <TWCText noTestID variant={'regularText30'}>
          {'Local Storage'}
        </TWCText>
      </View>
      <DebugLocalStorageContent />
    </TWCPage>
  );
};

const DebugLocalStorageContent = () => {
  const [storageString, setStorageString] = useState('');

  useEffect(() => {
    const getStorageOnLoad = async () => {
      const allStorage = await getAllStorage();
      let newStorageString = '';

      for (const key in allStorage) {
        let value = allStorage[key];

        try {
          value = JSON.parse(value);
          value = JSON.stringify(value, null, Array.isArray(value) ? null : 2);
        } catch (error) {}
        newStorageString += `${key}:\n${value}\n\n`;
      }

      setStorageString(newStorageString);
    };

    getStorageOnLoad();
  }, []);

  const scrollReference = useContextReference(testIDS.display);
  const buttonHandle = useContextNodeHandle(testIDS.clearButton);
  const scrollHandle = useContextNodeHandle(testIDS.display);

  // TODO fix this lint warning
  // eslint-disable-next-line react/no-unstable-nested-components
  const ScrollableDisplay = ({ focused }) => (
    <TWCScrollView isFocused={focused} scrollHeight={Theme.appHeight - Theme.px(250)} style={styles.scrollview}>
      <TWCText noTestID variant={'mediumText18'}>
        {storageString}
      </TWCText>
    </TWCScrollView>
  );

  return (
    <View style={styles.pageWrapper}>
      <FocusableHighlight
        nextFocusRight={buttonHandle}
        ref={scrollReference}
        style={styles.scrollviewWrapper}
        styleFocused={styles.focusedWrapper}
        testID={testIDS.display}
      >
        <ScrollableDisplay />
      </FocusableHighlight>

      <TWCButton
        nextFocusLeft={scrollHandle}
        testID={testIDS.clearButton}
        title={'Clear storage'}
        onPress={() => {
          clearStorage(false);
          setStorageString('\nLocal storage cleared');
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  focusedWrapper: {
    borderColor: Theme.white,
    borderWidth: 2,
  },
  pageTitleWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 20,
  },
  pageWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  scrollview: {
    height: Theme.appHeight - Theme.px(270),
    padding: Theme.px(10),
  },
  scrollviewWrapper: {
    backgroundColor: Theme.withOpacity(Theme.white, 0.1),
    flexGrow: 0,
    height: Theme.appHeight - Theme.px(250),
    marginRight: Theme.px(100),
    marginTop: Theme.px(100),
    width: Theme.appWidth / 2 - Theme.px(80),
  },
});
